import { HSActiveConfiguration } from './HSActiveConfiguration';

export class FoldingDoorActiveConfiguration extends HSActiveConfiguration {
    type: 'folding_door' = 'folding_door';
}
